import React, { useMemo } from 'react'
import { ThemeProvider } from '@mui/material/styles'
import { createMuiTheme, createMuiTheme2 } from '@/theme'
import { useColorMode } from '@/theme/ColorModeProvider'

/**
 * Picks light/dark theme for the current color mode.
 * @param {'default' | 'dashboard'} variant — dashboard uses the sm/lg breakpoint variant
 */
export default function AppThemeProvider({
  variant = 'default',
  children,
}) {
  const { resolvedMode } = useColorMode()

  const theme = useMemo(() => {
    return variant === 'dashboard'
      ? createMuiTheme2(resolvedMode)
      : createMuiTheme(resolvedMode)
  }, [resolvedMode, variant])

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}
